import { render, staticRenderFns } from "./MailsNoData.vue?vue&type=template&id=72af1414&scoped=true"
import script from "./MailsNoData.vue?vue&type=script&lang=js"
export * from "./MailsNoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72af1414",
  null
  
)

export default component.exports